var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgDesign = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.866 30.9221L30.9221 13.866L25.2367 8.30695L17.5299 16.1401C17.2772 16.2665 17.0245 16.3928 16.7718 16.3928C16.5191 16.3928 16.2665 16.2665 16.1401 16.1401L14.624 14.624C14.245 14.245 14.245 13.6133 14.624 13.2343L22.4572 5.4011L18.1616 1.23183C16.6455 -0.41061 14.1187 -0.41061 12.6026 1.23183L1.23183 12.4762C-0.41061 14.1187 -0.41061 16.6455 1.23183 18.1616L13.866 30.9221ZM62.8865 16.1401C65.2869 13.7396 65.2869 9.94939 62.8865 7.5489L57.2011 1.86354C54.8006 -0.536951 51.0104 -0.536951 48.6099 1.86354L42.7982 7.67524L57.0748 21.9518L62.8865 16.1401ZM40.0187 10.4548L2.49524 47.9782L0.0947561 61.6231C-0.284268 63.3918 1.35817 65.0343 3.12695 64.6552L16.7718 62.2548L54.2952 24.7313L40.0187 10.4548ZM63.5182 46.5884L59.3489 42.2928L51.5157 50.126C51.1367 50.505 50.505 50.505 50.126 50.126L48.6099 48.6099C48.2309 48.2309 48.2309 47.5991 48.6099 47.2201L56.4431 39.5133L50.884 33.8279L33.8279 50.884L46.5884 63.5182C48.1045 65.1606 50.6313 65.1606 52.2738 63.5182L63.5182 52.1474C65.1606 50.6313 65.1606 48.1045 63.5182 46.5884Z",
    fill: "#045091"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDesign, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/design.9f861405.svg";
export { ForwardRef as ReactComponent };